/** Parse `trashcoin_user` from localStorage without throwing (corrupt JSON breaks the whole app). */
export function readStoredUser(): Record<string, unknown> | null {
  try {
    const raw = localStorage.getItem('trashcoin_user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** First page after sign-in. Leave is under HR, so floor and admin staff do not land there. */
export function defaultTabForRole(role: unknown): string {
  if (role === 'USER') return 'vouchers';
  if (role === 'ADMINISTRATIVE') return 'settings';
  return 'dashboard';
}